// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,optimize_code_size
// @generated from protobuf file "qliq_protobuf/person_type.proto" (package "qliq_protobuf", syntax proto3)
// tslint:disable
/**
 * @generated from protobuf enum qliq_protobuf.PersonType
 */
export enum PersonType {
    /**
     * @generated from protobuf enum value: PERSON_PATIENT = 0;
     */
    PERSON_PATIENT = 0,
    /**
     * @generated from protobuf enum value: PERSON_PROVIDER = 1;
     */
    PERSON_PROVIDER = 1,
    /**
     * @generated from protobuf enum value: PERSON_CLINICIAN = 2;
     */
    PERSON_CLINICIAN = 2,
    /**
     * @generated from protobuf enum value: PERSON_CLIENT = 3;
     */
    PERSON_CLIENT = 3,
    /**
     * @generated from protobuf enum value: PERSON_TECHNICIAN = 4;
     */
    PERSON_TECHNICIAN = 4,
    /**
     * @generated from protobuf enum value: PERSON_PHYSICIAN = 5;
     */
    PERSON_PHYSICIAN = 5,
    /**
     * @generated from protobuf enum value: PERSON_NURSE = 6;
     */
    PERSON_NURSE = 6,
    /**
     * @generated from protobuf enum value: PERSON_CAREGIVER = 7;
     */
    PERSON_CAREGIVER = 7,
    /**
     * @generated from protobuf enum value: PERSON_THERAPIST = 8;
     */
    PERSON_THERAPIST = 8,
    /**
     * @generated from protobuf enum value: PERSON_MEMBER = 9;
     */
    PERSON_MEMBER = 9,
    /**
     * @generated from protobuf enum value: PERSON_EMPLOYEE = 10;
     */
    PERSON_EMPLOYEE = 10
}
